import { render, staticRenderFns } from "./EditProducts.vue?vue&type=template&id=3701bf6f&scoped=true&"
import script from "./EditProducts.vue?vue&type=script&lang=js&"
export * from "./EditProducts.vue?vue&type=script&lang=js&"
import style0 from "./EditProducts.vue?vue&type=style&index=0&id=3701bf6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3701bf6f",
  null
  
)

export default component.exports